import { FaturaResponsavelListSearchComponent } from './FaturaResponsavelListSearchComponent'

export const FaturaResponsavelListHeader = () => (
  <div className='card-header border-0 pt-6'>
    <FaturaResponsavelListSearchComponent />
  </div>
)
